import { heroStats } from "@/mocks/home";

export default function StatsStrip() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-site px-4 md:px-8">
        <div className="grid grid-cols-2 divide-background-200 md:grid-cols-4 md:divide-x">
          {heroStats.map((stat, i) => (
            <div
              key={stat.label}
              className={`flex flex-col gap-1.5 px-2 py-7 md:px-8 md:py-9 ${
                i % 2 === 0 ? "border-r border-background-200 md:border-r-0" : ""
              }`}
            >
              <span className="text-xs tracking-[0.2em] text-secondary-600">{stat.label}</span>
              <span className="flex items-baseline gap-1">
                <span className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
                  {stat.value}
                </span>
                <span className="text-sm text-foreground-500">{stat.unit}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}